import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { MONITORING, APPLICATION } from '../../src/config/variables';

export function dataDogProvider({ element }) {
    if (typeof window != 'undefined' && window.DATADOG_RUM_ENABLED === 'true') {
        datadogRum.init({
            applicationId: MONITORING.RUM.APPLICATION_ID,
            clientToken: MONITORING.RUM.CLIENT_TOKEN,
            site: 'datadoghq.com',
            service: 'main-website',
            // Specify a version number to identify the deployed version of your application in Datadog
            version: `${APPLICATION.VERSION}-${APPLICATION.ENV}`,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100, // Disable's session replays
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            storeContextsAcrossPages: true,
            defaultPrivacyLevel: 'mask-user-input',
            env: APPLICATION.ENV,
        });
    }

    return <>{element}</>;
}
